import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import type { PackageImageDTO } from "../../publicPackages/publicPackagesApi";
import { ImageBox } from "../CardImage";
import type { FormatType } from "./FormatSelector";

interface Props {
  readonly index: number;
  readonly day: {
    readonly dayNumber: number;
    readonly title?: string;
    readonly details: { readonly description?: string; readonly plan?: string };
    readonly image?: PackageImageDTO;
    readonly information?: string;
  };
  readonly format: FormatType;
  readonly onImageClick: (imageSrc: string) => void;
}

export const PackageDayDetails: FC<Props> = ({ index, day, format, onImageClick }) => {
  return (
    <Stack direction="row" spacing={3} sx={{ position: "relative", zIndex: 1 }}>
      {/* IDEALNE KÓŁKO (flexShrink: 0 naprawia błąd jajka!) */}
      <Box
        sx={{
          width: 40,
          height: 40,
          flexShrink: 0,
          borderRadius: "50%",
          bgcolor: "#fff",
          border: "2px solid",
          borderColor: "primary.main",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 0 0 4px #f4f6f8",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontWeight: "bold",
            color: "primary.main",
          }}
        >
          {index}
        </Typography>
      </Box>
      <Box sx={{ pt: 1, pb: 2, flexGrow: 1 }}>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontWeight: "bold",
            textTransform: "uppercase",
            letterSpacing: 1,
          }}
        >
          {day.dayNumber}. Dzień
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            mt: 0.5,
            mb: 1,
          }}
        >
          {day.title}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            lineHeight: 1.7,
            mb: 3,
            whiteSpace: "pre-line",
          }}
        >
          {day.details[format]}
        </Typography>

        {day.image && (
          <Box sx={{ mb: 2, borderRadius: 1, overflow: "hidden" }}>
            <ImageBox
              image={day.image}
              sx={{ width: "100%", aspectRatio: "16 / 9", objectFit: "cover", display: "block", cursor: "pointer" }}
              onClick={onImageClick}
            />
          </Box>
        )}

        {day.information && (
          <Accordion
            elevation={0}
            sx={{
              border: "1px solid rgba(0,0,0,0.08)",
              borderRadius: "8px !important",
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                sx={{
                  fontWeight: "500",
                }}
              >
                Informacje praktyczne
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  whiteSpace: "pre-line",
                }}
              >
                {day.information}
              </Typography>
            </AccordionDetails>
          </Accordion>
        )}
      </Box>
    </Stack>
  );
};
